export default "__VITE_ASSET__90cf88db__"